import ChatIcon from "./ChatIcon";
import DiscoverIcon from "./DiscoverIcon";
import HomeIcon from "./HomeIcon";
import InterestIcon from "./InterestIcon";
import ProfileDemo from "./ProfileDemo";
const BottomBarIcons = {
  ChatIcon,
  DiscoverIcon,
  HomeIcon,
  InterestIcon,
  ProfileDemo
};

export default BottomBarIcons;
